import Button from '@/components/common/Button/Button';
import { browserHistory } from '@/routing/browserHistory';
import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import usePrevNextContractIds from '../../../hooks/contract/usePrevNextContractIds.hook';

const constructRoute = (contractsPath: string, id: string | null | undefined) => {
  const filterName = new URL(window.location.href).searchParams.get('filterName') ?? '';
  const filterKey = new URL(window.location.href).searchParams.get('filterKey') ?? '';
  const search = new URL(window.location.href).searchParams.get('search') ?? '';
  const parentCustomerId = new URL(window.location.href).searchParams.get('parentCustomerId') ?? '';
  const parentAccountNumber = new URL(window.location.href).searchParams.get('parentAccountNumber') ?? '';

  const currentPath = window.location.pathname;
  const baseRoute = parentCustomerId ? contractsPath + '/customers' : contractsPath;

  let route = currentPath.includes('filteredBy') ?
    `/${baseRoute}/filteredBy/${id}?`
    : `/${baseRoute}/${id}?`;

  if (parentCustomerId) {
    route = route + `&parentCustomerId=${parentCustomerId}&parentAccountNumber=${parentAccountNumber}`;
  }

  if (filterName) {
    route = route + `&filterKey=${filterKey}&filterName=${filterName}`;
  }

  if (search) {
    route = route + `&search=${search}`;
  }

  return route;
};

const PrevNextButtons = ({ contractId, className }: { contractId: string, className: string }) => {
  const contractsPath = 'contracts-bc';

  const prevNextContractIds = usePrevNextContractIds(contractId);

  const hasRowIndex = !Number.isNaN(Number(prevNextContractIds?.rowIndex));

  if (!location.pathname.includes(contractsPath) || !hasRowIndex) {
    return null;
  }

  return (
    <div className={className}>
      <Button disabled={!prevNextContractIds?.prevID}
        onClick={() => {
          const route = constructRoute(contractsPath, prevNextContractIds?.prevID);
          browserHistory.replace(
            getParameterizedLink(`${route}&rowIndex=${prevNextContractIds?.rowIndex! - 1}`));
        }}>  Previous

      </Button>
      <Button disabled={!prevNextContractIds?.nextID}
        onClick={() => {
          const route = constructRoute(contractsPath, prevNextContractIds?.nextID);
          browserHistory.replace(
            getParameterizedLink(`${route}&rowIndex=${prevNextContractIds?.rowIndex! + 1}`));
        }}>    Next
      </Button>
    </div>
  );
};


export default PrevNextButtons;
